module.exports = __webpack_public_path__ + "static/img/329_TO8_2537_og.4f27943.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/329_TO8_2537_og.jpg
// module id = FC14
// module chunks = 0